

// for navbar
export const Links=[
    {
        id:1,
        link:"Home",
        path:'/'
    },
    {   
        id:2,
        link:"Blog",
        path:'/blog'
    },
    {
        id:3,
        link:"Management",
        path:'/management'
    },
    {
        id:4,
        link:"Visitors",
        path:'/visitors'
    },
    {  
        id:5,
        link:"Events",
        path:'/events'
    },
    {
        id:6,
        link:"Contact",
        path:'/contact'
    },
    {
        id:7,
        link:"Inspirations",
        path:'/inspirations'
	},
	{
		id: 8,
		link: "Flight",
		path: '/airline'
	},

    
]


// for services
export const Services=[
    {
        id:1,
		icon: "fas fa-home", 
        column:'Resturant',
		text:"A quality and relaxing rural country pub, run by award winning owners, in the beautiful Berkshire village of Peasemore."
    },
    {   
        id:2,
		icon:"fas fa-utensils",
        column:'Food',
        text:"We provide delicious and yummmy meals to our visitors.There are wide varieties of Food We offer."
    },
    {
        id:3,
		icon: "fas fa-couch",
        column:'Relaxation Bar',
		text:"During the relaxation response, the body moves toward a state of physiological relaxation, where blood pressure, heart rate, digestive functioning, and hormonal levels return to normal levels."
    },
    {
        id:4,
		icon: "fas fa-person-booth",
        column:'Standard Rooms',
        text:"We have standard rooms with unique electronic appliances, silk bed and well furnished chairs and Tables. We have as well a good working air-conditioner"
    },
  
  
]

// for services
export const Portfolio=[
    {
        id:1,
        img:"images/decor1.jpg",
        plus:"fas fa-plus"
       
    },
    {   
        id:2,
        img:"../../images/decor2.jpg",
        plus:"fas fa-plus"
    },
    {
        id:3,
        img:"../../images/decor3.jpg",
        plus:"fas fa-plus",
    },
    {
        id:4,
        img:"../../images/decor4.jpg",
        plus:"fas fa-plus"
    },
    {
        id:5,
        img:"../../images/decor5.jpg",
        plus:"fas fa-plus"
    },
    {
        id:6,
        img:"../../images/decor6.jpg",
        plus:"fas fa-plus"
    },
    {
        id:7,
        img:"../../images/decor7.jpg",
        plus:"fas fa-plus"
    },
    {
        id:8,
        img:"../../images/decor8.jpg",
        plus:"fas fa-plus"
    },
	{
		id: 9,
		img: "../../images/decor9.jpg",
		plus: "fas fa-plus"
	},
	{
		id: 10,
		img: "../../images/decor10.jpg",
		plus: "fas fa-plus"
	},
	{
		id: 11,
		img: "../../images/decor11.jpg",
		plus: "fas fa-plus"
	},
	{
		id: 12,
		img: "../../images/decor12.jpg",
		plus: "fas fa-plus"
	},

  
]


// for blogs
export const blogItems=[
    {
        id:1,
        img:"images/decor1.jpg",
        date:"30 march 2018",
        title:'Innovation',
        words:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur doloremque dolores dignissimos, ratione provident placeat cumque temporibus consectetur doloribus',
        number1:"896",
        number2:"5648",
    
       
    },
    {   
        id:2,
        img:"../../images/decor2.jpg",
        date:"12 april 2017",
        title:'New trends',
        words:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur doloremque dolores dignissimos, ratione provident placeat cumque temporibus consectetur doloribus',
        message:'fas fa-comment',
        number1:"1896",
      number2:"35648",
     
    },
    {
        id:3,
        img:"../../images/decor3.jpg",
        date:"11 june 2016",
        title:'Follow the future',
        words:'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolore pariatur doloremque dolores dignissimos, ratione provident placeat cumque temporibus consectetur doloribus',
        message:'fas fa-comment',
        number1:"1236",
       number2:"3648",
        
    },
   
  
]




// famous interiors
export const Interiors=[
    {
        id:1,
		name:'Mrs Abimbola F.',
        img:"images/interiors/interior1.png",
       
    
       
    },
    {   
        id:2,
        name:'Mr Raji F.',
        img:"images/interiors/interior2.png",
        
     
    },
    {
        id:3,
        name:'Mr Tayo',
        img:"images/interiors/interior3.png",
      
    },
    {
        id:4,
        name:'Davido(OBO)',
        img:"images/interiors/interior4.png",
      
    },
   
   
  
]



// recent events
export const Events=[
    {
        id:1,
       name:'Wedding',
       date:"16-8-2020",
       area:'Cvilla Hall'
       
    
       
    },
    {   
        id:2,
        name:'Night Club',
        date:"22-08-2020",
        area:'Cvilla Bar'
        
     
    },
    {
        id:3,
        name:'Worship Service',
        date:"22-08-2020",
        area:'Cvilla Hall'
      
    },
    {
        id:4,
        name:'Wedding',
        date:"29-08-2020",
        area:'Cvilla Hall'
      
    },
  
]





